import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith('/app')) return null;
  return (
    <footer className="border-t border-zinc-900 bg-[#0a0a0b] mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full border border-[#d4a94a] flex items-center justify-center">
              <span className="font-display text-[#d4a94a] text-lg font-semibold leading-none">R</span>
            </div>
            <span className="font-display text-xl text-zinc-100">Reachly</span>
          </Link>
          <p className="mt-4 text-sm text-zinc-500 max-w-sm">The job seeker's cold outreach machine. Multi-step email sequences to recruiters, sent from your own Outlook inbox.</p>
        </div>
        <div>
          <div className="text-zinc-300 text-sm font-medium mb-3">Product</div>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><a href="/#features" className="hover:text-[#f5d67a]">Features</a></li>
            <li><a href="/#pricing" className="hover:text-[#f5d67a]">Pricing</a></li>
            <li><Link to="/compare" className="hover:text-[#f5d67a]">Compare</Link></li>
            <li><a href="/#faq" className="hover:text-[#f5d67a]">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="text-zinc-300 text-sm font-medium mb-3">Alternatives</div>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/compare/apollo" className="hover:text-[#f5d67a]">Reachly vs Apollo</Link></li>
            <li><Link to="/compare/hunter" className="hover:text-[#f5d67a]">Reachly vs Hunter</Link></li>
            <li><Link to="/compare/contactout" className="hover:text-[#f5d67a]">Reachly vs ContactOut</Link></li>
            <li><Link to="/compare/lusha" className="hover:text-[#f5d67a]">Reachly vs Lusha</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-6 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-xs text-zinc-600">
        <span>© {new Date().getFullYear()} Reachly. Sent with care.</span>
        <span className="hidden md:inline text-zinc-800">·</span>
        <Link to="/help" className="hover:text-[#f5d67a]">Help</Link>
        <Link to="/privacy" className="hover:text-[#f5d67a]">Privacy</Link>
        <Link to="/tos" className="hover:text-[#f5d67a]">Terms</Link>
      </div>
    </footer>
  );
}
